import React, { useEffect, useState } from "react";
import SearchBar from "../Components/SearchBar";
import Dropdown from "../Components/Dropdown";
import OpenPositionCard from "../Components/OpenPositionCard";
import { useApidashboardMutation } from "../Store/Middleware/api/dashboardAPI";
import Cookies from "js-cookie";
import { useAllCategoryapiQuery } from "../Store/Middleware/api/getAllcategoryAPI";
import {
  Pagination,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Typography,
  Button,
} from "@mui/material";
import WorkOffIcon from "@mui/icons-material/WorkOff";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Hero from "../Components/Hero";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CardShimmer from "../Components/CardShimmer";
import DropDownCategory from "../Components/DropDownCategory";

const jobPosted = ["Any Time", "Past Week", "Last 24 Hours", "Past Month"];

const jobtype = [
  { name: "Contract", value: "C" },
  { name: "Contract To Hire", value: "C&H" },
  { name: "Freelance", value: "FL" },
  { name: "Hire", value: "Full Time" },
];

const MenuProps = {
  PaperProps: {
    style: {
      width: 200,
      overflowX: "hidden",
    },
  },
};

const Openposition = () => {
  const nav = useNavigate();
  const location = useLocation();
  const { category, isHome } = location?.state || {};

  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedOptions, setSelectedOptions] = React.useState([]);

  // Safely extract category string from possible object
  let safeCategory = category || "";
  if (typeof safeCategory === "object" && safeCategory !== null) {
    safeCategory = safeCategory.value || safeCategory.name || "";
  }

  const [filterData, setFilterData] = useState({
    description: "",
    location: "",
    page: 1,
    company: "",
    jobPostedOn: "Any Time",
    category: isHome ? [safeCategory] : safeCategory ? [safeCategory] : [],
    jobType: [],
    cover_letter_required: 0,
  });

  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [apiDashboard, result] = useApidashboardMutation();
  const { data } = useAllCategoryapiQuery();
  const description = searchParams.get("category");
  const [searchData, setSearchData] = useState({
    description: description || "",
    location: "",
  });

  useEffect(() => {
    if (searchData.description === "") {
      setFilterData((prev) => ({ ...prev, description: "", page: 1 }));
    }
  }, [searchData.description]);

  const formatDataforSearchParams = (valArr, originalArr, value) => {
    if (typeof valArr === "string") return valArr;
    if (!Array.isArray(valArr)) return "";
    const name = valArr.map((val) => {
      const job = originalArr?.find((job) => job[value] === val);
      return job ? job.name : null;
    });
    return name.join(",");
  };

  const formatCategoryforSearchParams = (categories) => {
    if (typeof categories === "string") return categories;
    if (Array.isArray(categories)) return categories.join(",");
    return "";
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setSearchParams({
      category: formatCategoryforSearchParams(filterData.category),
      location: filterData.location,
      jobPostedOn: filterData.jobPostedOn,
      jobType: formatDataforSearchParams(filterData.jobType, jobtype, "value"),
      company: formatDataforSearchParams(
        filterData.company,
        data?.message?.company,
        "company_id",
      ),
    });

    getAllData();
    document.title = "Open Positions | Career Portal";

    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.href =
        "https://spanlogo.s3.ap-south-1.amazonaws.com/Spanidea-Blue-Favion-2025.png";
    } else {
      const link = document.createElement("link");
      link.rel = "icon";
      link.href =
        "https://spanlogo.s3.ap-south-1.amazonaws.com/Spanidea-Blue-Favion-2025.png";
      document.head.appendChild(link);
    }
  }, [filterData]);

  const getAllData = async () => {
    const response = await apiDashboard({
      description: filterData.description,
      location: filterData.location,
      token: Cookies.get("authToken"),
      page: filterData.page,
      company: filterData.company,
      jobPostedOn: filterData.jobPostedOn,
      category: filterData.category,
      jobType: filterData.jobType,
      workmode: filterData.workmode,
      candidate: localStorage.getItem("email"),
    });
    if (response?.data?.success) {
      setResponseData(response?.data?.message?.dashboard);
    }
    if (response?.status === 401) {
      localStorage.clear();
      Cookies.remove("_secure_ARJ_");
      window.location.href = "/login";
    }
  };

  const handleJobChange = (e) => {
    setFilterData((prev) => ({ ...prev, jobPostedOn: e.target.value }));
  };

  const handlePageChange = (e, value) => {
    setFilterData((prev) => ({ ...prev, page: value }));
  };

  const handleReset = () => {
    setIsLoading(false);
    setFilterData({
      description: "",
      location: "",
      page: 1,
      company: "",
      jobPostedOn: "Any Time",
      category: [],
      jobType: [],
      cover_letter_required: 0,
    });
    // ✅ BUG FIX 1: Reset karte waqt searchData bhi clear karo
    setSearchData({ description: "", location: "" });
    setSelectedOptions([]);
  };

  useEffect(() => {
    if (selectedOptions.length > 0 || filterData.jobType.length > 0) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [selectedOptions, filterData.jobType]);

  return (
    <section className="openPositionSection">
      <Hero
        heading={"Open Positions"}
        subHeading={"Live your best life and do your best work with us"}
      />

      <div className="openPosition-m3">
        <div className="filterFieldsWrapper">
          <div className="openPosition-serachBar">
            <SearchBar
              setFilterData={setFilterData}
              searchData={searchData}
              setSearchData={setSearchData}
              description={description}
            />
          </div>

          <div className="openPosition-dropdown">
            <Box className="postedOnFilter_div">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" sx={{ top: "-5px" }}>
                  Job Posted on
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={filterData.jobPostedOn}
                  label="Job Posted on"
                  onChange={handleJobChange}
                  MenuProps={MenuProps}
                  sx={{
                    borderRadius: "25px",
                    position: "unset",
                    "& .MuiSelect-select": { padding: "10px 16px" },
                  }}
                >
                  {jobPosted.map((job) => (
                    <MenuItem key={job} value={job}>
                      {job}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <div>
              <Dropdown
                name={"Job Type"}
                setFilterData={setFilterData}
                data={jobtype}
                valueField={"value"}
                initialValue={filterData.jobType}
              />
            </div>

            <div>
              <DropDownCategory
                name={"Category"}
                setFilterData={setFilterData}
                data={data?.message?.category}
                filterData={filterData}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
              />
            </div>

            <div>
              <Button
                variant="contained"
                style={{
                  backgroundColor: isLoading ? "#D3D3D3" : "#165DFF",
                }}
                onClick={handleReset}
                disabled={isLoading}
              >
                <RestartAltIcon /> Reset
              </Button>
            </div>
          </div>
        </div>

        <div className="hrPositionMain">
          <div className="hrOpenPosition"></div>
        </div>

        {result.isLoading ? (
          <div className="openPosition-Card JBScroll">
            {Array.from({ length: 10 }).map((_, index) => (
              <CardShimmer key={index} />
            ))}
          </div>
        ) : responseData?.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "40vmin",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <WorkOffIcon sx={{ fontSize: "20vmin", color: "#D3D3D3" }} />
            <Typography sx={{ fontSize: "2.5vmin", color: "#D3D3D3" }}>
              No Jobs Available
            </Typography>
          </Box>
        ) : (
          // ✅ BUG FIX 1: justify-content: flex-start added inline
          // taaki cards hamesha left se start hon
          <div
            className="openPosition-Card JBScroll"
            style={{ justifyContent: "flex-start" }}
          >
            {responseData?.map((item, index) => {
              return item.isApproved ? (
                <div
                  onClick={() =>
                    nav(`/authPage/jobdetails/${item.joborder_id}`)
                  }
                  key={index}
                  className="openPositionCardMain"
                >
                  <OpenPositionCard data={item} />
                </div>
              ) : null;
            })}
          </div>
        )}

        {responseData?.length !== 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "15px",
            }}
          >
            <Pagination
              count={1}
              onChange={handlePageChange}
              page={filterData.page}
              sx={{
                "& .Mui-selected": {
                  background: "#165DFF !important",
                  color: "#fff",
                },
              }}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default Openposition;
